import { BidV2Status, type BidV2Dto } from "../../../../../autogen/bff-api";

export const isReadonlyBidStatus = (status: BidV2Status): boolean =>
  status === BidV2Status.Submitted ||
  status === BidV2Status.Awarded ||
  status === BidV2Status.Rejected;

type LockFields = Pick<BidV2Dto, "status" | "submissionDeadlinePassed" | "signedDocumentId">;

export const isBidLockedByDeadline = (bid: LockFields): boolean =>
  bid.status === BidV2Status.Draft && bid.submissionDeadlinePassed === true && bid.signedDocumentId == null;

export const isSubmittedBidLockedByDeadline = (bid: LockFields): boolean =>
  bid.status === BidV2Status.Submitted && bid.submissionDeadlinePassed === true;

export const showsReadonlyBid = (bid: LockFields): boolean =>
  isReadonlyBidStatus(bid.status) || isBidLockedByDeadline(bid);
